import React from 'react'

import { createValidIcon } from '@ui/icons/utils/type-helper'

export const MoneyIcon = createValidIcon((props) => {
  const { size, color } = props

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M11.9999 2.9165C12.5573 2.9165 13.0092 3.36837 13.0092 3.92577V4.352C15.2033 4.74485 17.0463 6.39324 17.0463 8.63568C17.0463 9.19309 16.5944 9.64495 16.037 9.64495C15.4796 9.64495 15.0277 9.19309 15.0277 8.63568C15.0277 7.72269 14.2686 6.75628 13.0092 6.4119V11.0804C15.2033 11.4733 17.0463 13.1217 17.0463 15.3641C17.0463 17.6066 15.2033 19.255 13.0092 19.6478V20.074C13.0092 20.6314 12.5573 21.0833 11.9999 21.0833C11.4425 21.0833 10.9907 20.6314 10.9907 20.074V19.6478C8.79663 19.255 6.95361 17.6066 6.95361 15.3641C6.95361 14.8067 7.40548 14.3549 7.96288 14.3549C8.52028 14.3549 8.97215 14.8067 8.97215 15.3641C8.97215 16.2771 9.73125 17.2435 10.9907 17.5879V12.9194C8.79663 12.5265 6.95361 10.8781 6.95361 8.63568C6.95361 6.39324 8.79663 4.74485 10.9907 4.352V3.92577C10.9907 3.36837 11.4425 2.9165 11.9999 2.9165ZM10.9907 6.4119C9.73125 6.75628 8.97215 7.72269 8.97215 8.63568C8.97215 9.54868 9.73125 10.5151 10.9907 10.8595V6.4119ZM15.0277 15.3641C15.0277 14.4511 14.2686 13.4847 13.0092 13.1403V17.5879C14.2686 17.2435 15.0277 16.2771 15.0277 15.3641Z'
        fill={color}
      />
    </svg>
  )
})
